<template>
  <div class="pc-search">
    <el-form :model="keywordData" :inline="true">
      <el-form-item label="标题" class="title">
        <el-input
          v-model="keywordData.title_keywords[0]"
          placeholder="请输入新闻标题/名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="类型" class="type">
        <el-select
          clearable
          v-model="keywordData.news_type"
          placeholder="选择类型"
        >
          <el-option
            v-for="(item, key) in typeList"
            :label="item"
            :value="item"
            :key="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <br/>
      <el-form-item label="关键词" class="keyword">
        <keywordsinput
          :maxLen="18"
          v-model="keywordData.tags_keywords"
        ></keywordsinput>
      </el-form-item>
      <el-form-item label="新闻ID" class="number">
        <el-input-number
          v-model="keywordData.id"
          placeholder="请输入新闻ID"
          clearable
        ></el-input-number>
      </el-form-item>
      <el-form-item label="主题" class="topic">
        <el-select
          clearable
          v-model="keywordData.topic_id"
          placeholder="选择主题"
        >
          <el-option
            v-for="(item, key) in topicList"
            :label="item.english_name"
            :value="item.id"
            :key="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <br/>
      <el-form-item label="状态" placeholder="状态" class="status">
        <el-select v-model="keywordData.status" placeholder="有效" clearable>
          <el-option label="有效" value="1">有效</el-option>
          <el-option label="无效" value="0">无效</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发布时间" class="updateTime">
        <el-date-picker
          v-model="keywordData.publish_time"
          type="daterange"
          clearable
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <button  class="pc-search-btn" @click="search">筛选</button>
  </div>
</template>

<script>
import { getTopics_Api } from "@/apis/news.api";
export default {
  components: {},
  data() {
    return {
      keywordData: {
        title_keywords: [""],
        news_type: "",
        tags_keywords: [],
        id: null,
        topic_id: "",
        status: "",
        publish_time: null,
      },
      typeList: ["News", "Events", "Exploration"],
      topicList: [],
    };
  },
  mounted() {
   this.getTopics()
  },
  methods: {
    getTopics(){
       getTopics_Api()
      .then((res) => {
        this.topicList = res.data;
      })
    },
    search() {
      this.$emit("search", this.keywordData);
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-search {
  @include table-search;
  .title {
    width: 400px;
  }
  .type {
    width: 300px;
  }
  .keyword {
    width: 400px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
  .number {
    width: 300px;
    /deep/ .el-input-number{
      width:190px;
    }
  }
  .topic {
    width: 300px;
  }
  .status {
    width: 200px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/news/components/NewsSearch.vue